import {Component, computed, inject, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ArrowRightFromLineIcon, ArrowRightToLineIcon, LucideAngularModule, MapPinIcon} from 'lucide-angular';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityScheduleDTO} from '@domain/activity/schedule/schedule.dto';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {
  ScheduleTimeComponent
} from '@domain/activity/schedule/component/schedule-display/schedule-time/schedule-time.component';
import {
  ScheduleValidityComponent
} from '@domain/activity/schedule/component/schedule-display/schedule-validity/schedule-validity.component';

@Component({
  selector: 'app-schedule-preview',
  imports: [
    TranslocoDirective,
    LucideAngularModule,
    ScheduleTimeComponent,
    ScheduleValidityComponent
  ],
  providers: [
    VenuePipe
  ],
  templateUrl: './schedule-preview.component.html',
  styleUrl: './schedule-preview.component.scss'
})
export class SchedulePreviewComponent {
  public readonly activity = input.required<ActivityDTO>();
  public readonly schedule = input.required<ActivityScheduleDTO>();
  public readonly isPublic = input.required<boolean>();
  public readonly showDistance = input(true);

  public readonly icons = {
    map: MapPinIcon,
    since: ArrowRightFromLineIcon,
    until: ArrowRightToLineIcon
  };

  public readonly isFinished = computed(() => ActivityScheduleUtil.isFinished(this.schedule()));

  public readonly venueText = computed(() => {
    const distance = this.distance();
    let venueStr = this.showDistance() && distance ? distance + ' - ' : '';
    venueStr += this.activityVenuePipe.transform(this.schedule().venue, {showAddress: false});
    return venueStr;
  });

  private readonly distance = computed(() => {
    const distance = this.schedule()?.venue?.distance;
    if (!distance) {
      return null;
    }
    if (distance > 1000) {
      return (distance / 1000).toFixed(1) + ' km';
    }
    return '< 1 km'
  });

  private readonly activityVenuePipe = inject(VenuePipe);
}
